import { Box, Text } from '@everlywell/ui-kit';
import { SectionHeader } from 'components/SectionHeader';
import VideoGallery from 'components/VideoGallery';
import React from 'react';

const videoData = [
  {
    id: '1',
    thumbnail:
      'https://images.ctfassets.net/6huuyzvsw0nv/Xv22MyC1T7tDCmBNNeBZ8/d38258d0ee9ae9d471e24eb1f08e4d23/george_thumb.png',
    poster:
      'https://images.ctfassets.net/6huuyzvsw0nv/76gQencSIXg2u5QYEhO1jx/195bebdc1c6582f9d1a7538e41629c6c/george_poster.jpg',
    videoUrl:
      'https://videos.ctfassets.net/6huuyzvsw0nv/5dxWwqIDpGvDRPyU4Hobwv/53db408c742fb07d7cbfcb2ac35ae9ec/EDWARD_DOYLE.mp4',
    title: 'George',
    subtitle:
      '73, Medicare member with no PCP takes action with FIT screening to support identification of early stage colorectal cancer',
    sections: [
      {
        title: 'Easy at-home lab tests',
        content: [
          "George hasn't seen a provider—scheduling an appointment was a hassle.",
          'He knew he needed to address his GI symptoms but felt overwhelmed about where to start.',
          'He’s pleasantly surprised to get a FIT kit from his health plan in the mail; he completes it and sends it back.',
          'George receives abnormal test results and answers an Alert Outreach call to set up a physician virtual visit to discuss his FIT kit findings.',
          'He’s glad he could take action from the comfort of his home.',
        ],
      },
      {
        title: 'A thorough telehealth appointment',
        content: [
          'George does not have a primary care provider and has not been to see a provider in several years.',
          'He quickly connects with a provider via telehealth within 24 hours of receiving abnormal test results.',
          'In his virtual visit, the member states he has high cholesterol and has observed blood in his stool for the past several months.',
          'Patient reports diarrhea, weight loss of 8 pounds.',
        ],
      },
      {
        title: 'Outcomes and actionable care plan',
        content: [
          'George’s provider supports an expedited colonoscopy for positive FIT which identifies early stage colorectal cancer and may prevent the cost and burden associated with advanced stage treatments.',
          'George avoids long appointment wait times to see a GI specialist for evaluation and a fragmented medical experience with providers.',
          'Continuity of care is supported with a care summary and referral sent to the GI specialist and primary care provider referral. ',
        ],
      },
    ],
  },
  {
    id: '2',
    thumbnail:
      'https://images.ctfassets.net/6huuyzvsw0nv/7zzyIEa7tznZlSiy9dISZs/d0b9bbc1d168214c899c34d0476a0b7f/glenn_thumb.png',
    poster:
      'https://images.ctfassets.net/6huuyzvsw0nv/3F8e6p0CslfeaMU72SlWWE/b40ab1c33469381d3eb56c2856fa29c1/glenn_poster.png',
    videoUrl:
      'https://videos.ctfassets.net/6huuyzvsw0nv/7Jy0q4DfYRzpq9pitv9OEh/768bf0e13ce4e60d4669e34ad9ba3caa/CHRISTIAN_A.mp4',
    title: 'Glenn',
    subtitle:
      '47-year-old shift worker and busy parent uses a virtual check up to identify high cholesterol and establish ongoing care',
    sections: [
      {
        title: 'Easy at-home lab tests',
        content: [
          'Member receives an Everlywell at-home HbA1c test as part of his health plan’s outreach because he was previously listed as diabetic.',
          'Despite being a bit nervous, he decides to complete the test.',
          'The results show an HbA1c of 10.1%, indicating uncontrolled diabetes.',
          'He assumed he was managing his diabetes well because he recently changed his diet, eliminating fried foods.',
        ],
      },
      {
        title: 'A thorough telehealth appointment',
        content: [
          'George does not have a primary care provider and has not been to see a provider in several years.',
          'Glenn answers the Alert Outreach call to set up a virtual visit for the same day.',
          'He is pleased to set up the appointment because his PCP recently retired and he has not yet found a new one. He has been unsure of who to turn to talk about his health and mood.',
          'He does not have easy transportation to get to a lab or provider’s office.',
          'Clinical staff help him to complete a number of screenings, record his self-reported conditions including depression, obesity, diabetes, hypertension and family history of cardiovascular disease.',
          'Physician reviews his HbA1c results, screenings and medical history. ',
        ],
      },
      {
        title: 'Outcomes and actionable care plan',
        content: [
          'Physician initiates diabetes management with GLP-1 medication and reviews a detailed care plan with diet and exercise.',
          'Glenn is referred to a local primary care provider, registered dietitian and behavioral health specialist to establish important ongoing care.',
          'Eight months later, Glenn receives a follow-up HbA1c test. His results are much improved at 7.9%.',
          'Provide a clear and actionable plan for managing diabetes, Glenn may reduce his risk for developing chronic kidney disease and diabetes-related complications.',
        ],
      },
    ],
  },
  {
    id: '3',
    thumbnail:
      'https://images.ctfassets.net/6huuyzvsw0nv/24Th5lAqGjfif9Xq045Nhv/34d995ea65b32d6793d6c5707dec55ce/eric_thumb.png',
    poster:
      'https://images.ctfassets.net/6huuyzvsw0nv/5891Vs6UU5iHfbhBMioEF0/9e56cb933c1f2461f9bf335d9708c490/eric_poster.png',
    videoUrl:
      'https://videos.ctfassets.net/6huuyzvsw0nv/5e3LQiUwToHT2NCjUfurc1/8f9252b35fb658d8f4b4da3e2536feb4/STEPHEN.mp4',
    title: 'Eric',
    subtitle:
      '31-year-old Medicaid member lowers HbA1c and controls diabetes within 9 months of treatment',
    sections: [
      {
        title: 'Easy at-home lab tests',
        content: [
          'Eric answers the Alert Outreach call to set up a virtual visit for the same day.',
          'He is pleased to set up the appointment because his PCP recently retired and he has not yet found a new one. He has been unsure of who to turn to talk about his health and mood.',
          'He does not have easy transportation to get to a lab or provider’s office.',
          'Clinical staff help him to complete a number of screenings, record his self-reported conditions including depression, obesity, diabetes, hypertension and family history of cardiovascular disease.',
          'Physician reviews his HbA1c results, screenings and medical history.',
        ],
      },
      {
        title: 'A thorough telehealth appointment',
        content: [
          'George does not have a primary care provider and has not been to see a provider in several years.',
          'He quickly connects with a provider via telehealth within 24 hours of receiving abnormal test results.',
          'In his virtual visit, the member states he has high cholesterol and has observed blood in his stool for the past several months.',
          'Patient reports diarrhea, weight loss of 8 pounds.',
        ],
      },
      {
        title: 'Outcomes and actionable care plan',
        content: [
          'Physician initiates diabetes management with GLP-1 medication and reviews a detailed care plan with diet and exercise.',
          'Eric is referred to a local primary care provider, registered dietitian and behavioral health specialist to establish important ongoing care.',
          'Eight months later, Eric receives a follow-up HbA1c test. His results are much improved at 7.9%.',
          'Provide a clear and actionable plan for managing diabetes, Eric may reduce his risk for developing chronic kidney disease and diabetes-related complications.',
        ],
      },
    ],
  },
  {
    id: '4',
    thumbnail:
      'https://images.ctfassets.net/6huuyzvsw0nv/1PbWovV7EorH4rOhvuZw4D/1620af2cb3a3591addcc49fe807d2f34/jill_thumb.png',
    poster:
      'https://images.ctfassets.net/6huuyzvsw0nv/6BZNSs9KS2EAAs8ZhTs1WN/439de01de236527f7c65e32cbd8794f3/jill_poster.png',
    videoUrl:
      'https://videos.ctfassets.net/6huuyzvsw0nv/5Moy196sm52Ml46k9xRDLZ/0aaf336cc35c33ac983f6cb2ecb989ac/SHANNON_H.mp4',
    title: 'Jill',
    subtitle:
      '53-year-old woman takes control of heart health with at-home Lp(a) test and new treatment options',
    sections: [
      {
        title: 'Easy at-home lab tests',
        content: [
          'Patient has been wondering about her heart health risks for years but never found the time to follow up on it.',
          'She researches online and learns about Lp(a), a genetic factor affecting cholesterol.',
          'She decides to take action and orders an Lp(a) test from her health plan.',
          'Through her employer, she discovers Everlywell’s Heart Health program and orders an at-home Lp(a) lab test.',
          'She is delighted by the convenience of at-home testing, empowered to take control and inspired by new information she has found.',
        ],
      },
      {
        title: 'A thorough telehealth appointment',
        content: [
          'Jill receives an outreach call after her elevated Lp(a) results, prompting her to schedule a virtual visit.',
          'During the virtual visit, the provider reviews her results and lets her know she can receive updates on new Lp(a) treatments as they become available.',
          'Receiving clear, personalized and supportive guidance and education eased her anxiety and confusion over her test results.',
        ],
      },
      {
        title: 'Outcomes and actionable care plan',
        content: [
          'Provider creates Jill a personalized care plan which includes immediate steps and longer-term strategies, with ongoing monitoring as new Lp(a) treatments become available.',
          'She checks the box to be notified about new treatments for elevated Lp(a) as they become available to ensure ongoing care.',
          'Jill now has clarity on her heart health risks, how to navigate new treatment options for Lp(a) and how they fit into her care plan.',
        ],
      },
    ],
  },
];

interface VideoSectionProps {
  title: string;
  headline: string;
}

export default function VideoSection({ title, headline }: VideoSectionProps) {
  return (
    <Box w="100%" maxW="1440px" mx="auto" px="1rem" py={[10, 20, 20]}>
      <SectionHeader eyebrow={title} title={headline} align="left" />
      <VideoGallery videoData={videoData} />
      <Text fontSize="sm" color="#666666" mt={10}>
        ** Actor portrayal; Representative testimonial.
      </Text>
    </Box>
  );
}
